import { useCallback, useEffect } from 'react';

import { BannerMenuActionTypes } from '@/components/EditorBuilder/BannerMenu';
import { CoverType } from '@/modules/corporate/components/ImageList/types';

import { CoverProps } from '../types';

const useBanner = (
  toggleCoverDialog: (nextValue?: boolean) => void,
  onCoverSave: (cover: CoverProps) => void,
  toggleRepositioning: (nextValue?: any) => void,
  imageOffsetPercent: number,
  setImageOffsetPercent: (val: number) => void,
  cover: { src: string; yOffsetPercent: number },
) => {
  useEffect(() => {
    setImageOffsetPercent(cover.yOffsetPercent);
  }, [cover.yOffsetPercent, setImageOffsetPercent]);

  const onMenuAction = useCallback(
    (value: string) => {
      switch (value) {
        case BannerMenuActionTypes.Reposition:
          toggleRepositioning(true);
          break;
        case BannerMenuActionTypes.Replace:
          toggleCoverDialog();
          break;
        case BannerMenuActionTypes.Remove:
          onCoverSave({ picture: '', yOffsetPercent: 0 });
          break;
        default:
          return;
      }
    },
    [toggleRepositioning, toggleCoverDialog, onCoverSave],
  );

  const onSubmitCover = useCallback(
    (selectedCover?: CoverType) => {
      if (selectedCover?.url) {
        onCoverSave({ picture: selectedCover.url, yOffsetPercent: 0 });
      }
    },
    [onCoverSave],
  );

  const onSavePosition = useCallback(() => {
    toggleRepositioning(false);
    onCoverSave({
      picture: cover.src,
      yOffsetPercent: imageOffsetPercent,
    });
  }, [cover.src, imageOffsetPercent, onCoverSave, toggleRepositioning]);

  const onCancel = useCallback(() => {
    toggleRepositioning(false);
    setImageOffsetPercent(cover.yOffsetPercent);
  }, [cover.yOffsetPercent, setImageOffsetPercent, toggleRepositioning]);

  return { onMenuAction, onSavePosition, onCancel, onSubmitCover };
};

export default useBanner;
